import { Skeleton } from '@/shared/components/ui/skeleton';

/** Route-level loading state while the team overview's first-page data is populated. */
export function SupervisorTeamPendingState() {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-4 p-4" aria-busy="true">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="space-y-2">
          <Skeleton className="h-6 w-40" />
          <Skeleton className="h-4 w-56" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-8 w-36" />
          <Skeleton className="h-8 w-40" />
        </div>
      </div>
      <Skeleton className="h-28 shrink-0" />
      <div className="grid min-h-0 flex-1 gap-4 lg:grid-cols-2">
        <Skeleton className="min-h-56" />
        <Skeleton className="min-h-56" />
      </div>
    </div>
  );
}
